<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <!-- @click="onSearchBtnClick" -->
    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="getData"
    >查询</el-button>
  </template>

  <template #body>
    <el-table
      ref="table"
      :data="list"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      style="width: 100%"
      @row-click="onOpenEditor"
    >
      <!-- <el-table-column label="序号" width="50">
        <template slot-scope="{$index}">{{$index + 1}}</template>
      </el-table-column> -->

      <el-table-column prop="dataTime" label="日期" />
      <el-table-column prop="aqiPollutionTimesStr" label="污染时段">
        <template slot-scope="{row}">
          <span v-html="row.aqiPollutionTimesStr"></span>
        </template>
      </el-table-column>
      <el-table-column prop="maxAqi" label="AQI峰值" />
      <el-table-column prop="aqiGradeStr" label="污染等级" />
      <el-table-column prop="primaryPollutionsStr" label="首要污染物" />
      <!-- <el-table-column prop="status" label="状态" /> -->
    </el-table>
  </template>

  <template #footer>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total"
      style="float: right;"
    >
    </el-pagination>
  </template>

  <template #editor>
    <editor
      ref="editor"
      :unit-prop="unitProp"
      :wind-query="windQuery"
      :characteristic-list="characteristicList"
    />
  </template>
</layout-content>
</template>

<script>
import YaoBaseSiteFactorData from '../../../../YaoBaseSiteFactorData'
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'
import DataFormatter from '../../../../../model/DataFormatter'
import Editor from './Editor'

export default {
  name: 'CreatePollutionCases',
  routeInfo: {
    label: '创建案例',
    icon: 'fa fa-users'
  },
  extends: YaoBaseSiteFactorData,
  components: {Editor},
  data: () => ({
    query: {},
    characteristicList: [],
    list: [],
    data42List: [],
    query42: {},
    windQuery: {},
    tmpWindList: [],
    dataList: [],
    pageSize: 100,
    currentPage: 1,
    total: 0
  }),
  computed: {
    // grade状态码
    gradeLevel () {
      return {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }
    },
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, true, siteDeviceFactors => {
          return siteDeviceFactors.filter(siteDeviceFactor => /^101(0|1|2|3|4)|8000|8001$/.test(siteDeviceFactor.factorId))
        }),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1001')),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1003')),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1005')),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => /^100(7|8)$/.test(siteDeviceFactor.factorId)))
      ]
    }
  },
  methods: {
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.currentChangePage(this.datasList, currentPage)
    },
    currentChangePage (list, currentPage) {
      let from = (currentPage - 1) * this.pageSize
      let to = currentPage * this.pageSize
      this.list = []

      for (; from < to; from++) {
        if (list[from]) {
          this.list.push(list[from])
        }
      }
    },
    onOpenEditor (model) {
      let query = {
        dataType: 60,
        siteIds: [model.siteId],
        beginTime: model.dataTime + ' 00:00:00',
        endTime: model.dataTime + ' 23:59:59'
      }
      let query42 = {
        ...query,
        factorIds: ['1001', '1003', '1005', '1006', '1007', '1008'],
        granularity: 1,
        isAuditCompleted: false,
        isSiteMerge: true,
        isTimeMerge: false
      }
      let windQuery = {
        ...query,
        factorIds: ['1010', '1011', '1012', '1013', '1014', '8000', '8001'],
        isAuditCompleted: false,
        isGetInvalidData: true,
        isMultipleIntegral: true
      }
      this.windQuery = Object.freeze(windQuery)
      this.query42 = Object.freeze(query42)
      let backData = {}
      this.changeLoadStatus(true)
      Promise.all([this.$api.Aqi.getAQIData(query42), this.$api.Data.getHistoryData(windQuery)]).then(([data42, windData]) => {
        if (!data42.length) {
          this.data42List = []
        } else {
          let temp = data42.map(el => {
            let arr = []
            el.pollutantData.forEach(item => {
              arr.push({
                dataTime: el.dataTime,
                factorId: item.factorId,
                siteId: query42.siteIds[0],
                value: item.value
              })
            })
            return arr
          })

          this.setDataList(temp.flat(), 'tmp42List', 'data42List', 'query42')
          backData.data42 = temp.flat()
        }
        backData.windData = windData

        this.setWindDataList(windData, 'tmpWindList', 'dataWindList', 'windQuery')
      }).catch(console.error).finally(() => {
        let refEditor = this.$refs.editor
        refEditor && refEditor.open(Object.assign(model, {
          ...backData,
          formatData42: this.data42List,
          formatDataWind: this.dataWindList
        }))
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList, tmpKey, dataKey, queryKey) {
      this.tmp42List = Object.freeze(dataList)
      this.formatData(tmpKey, dataKey, queryKey)
    },
    setWindDataList (dataList, tmpKey, dataKey, queryKey) {
      this.tmpWindList = Object.freeze(DataFormatter.formatWeatherDataList.bind(this)(dataList))
      this.formatData(tmpKey, dataKey, queryKey)
    },
    format (query42, otherDimensionProp, formatter, oDataListProp, dataListProp) {
      let {dimension} = this
      let otherDimension = dimension ^ 1

      let dimensionIdProps = new Array(2)
      dimensionIdProps[dimension] = 'siteId'
      dimensionIdProps[otherDimension] = otherDimensionProp
      let [dimensionIdProp0, dimensionIdProp1] = dimensionIdProps

      let dimensionIds = new Array(2)
      dimensionIds[dimension] = query42.siteIds
      dimensionIds[otherDimension] = query42.factorIds
      let [dimensionIds0, dimensionIds1] = dimensionIds

      let {siteFactorMap, factorSiteMap} = this
      let dimensionObjects = new Array(2)
      dimensionObjects[dimension] = siteFactorMap
      dimensionObjects[otherDimension] = factorSiteMap
      let dimensionObjectMap = dimensionObjects[0]

      let tmpList = this[oDataListProp]
      let {completeAllData} = this
      let beginTS = new Date(query42.beginTime).getTime()
      let dataList = Object.values(tmpList.reduce((map, data) => {
        let newData = map[data[dimensionIdProp0]]

        if (newData) {
          let {dataTime} = data
          let ts = new Date(dataTime).getTime()

          if (ts > newData.endTS) {
            newData.endTS = ts
          }

          formatter(data, newData, dimensionIdProp1, ts, dataTime)
        }

        return map
      }, dimensionIds0.reduce((map, dimensionId) => {
        let dimensionObject = dimensionObjectMap[dimensionId]
        let subDimensionMap = dimensionObject.map
        let seriesDimensions = dimensionIds1.reduce((list, id) => {
          let dimensionObj = subDimensionMap[id]

          if (dimensionObj) {
            list.push(dimensionObj)
          }

          return list
        }, [])

        map[dimensionId] = {
          id: dimensionId,
          name: dimensionObject.name,
          beginTS,
          endTS: completeAllData ? new Date(query42.endTime).getTime() : beginTS,
          dimensions: seriesDimensions,
          selectedNames: dimensionObject.selectedNames,
          seriesMap: seriesDimensions.reduce((map, seriesDimension) => {
            map[seriesDimension.id] = []
            return map
          }, {})
        }

        return map
      }, {})))

      let {unitProp} = this
      let data = Object.freeze(DataFormatter[`completeAndUnitConvert${query42.dataType}`](dataList, unitProp))
      this.totalDataTimes = Object.freeze(data.totalDataTimes)
      this[dataListProp] = Object.freeze(data.dataList)
    },
    formatData (tmpKey, dataKey, queryKey) {
      console.time('format2')

      let {valueProp} = this
      let query = this[queryKey]

      if (Object.keys(query).length === 0) {
        return
      }

      this.format.bind(this)(query, 'factorId', (data, newData, dimensionIdProp1, ts, dataTime) => {
        let value = data[valueProp]

        if (Number.isFinite(value)) {
          let series = newData.seriesMap[data[dimensionIdProp1]]

          if (series) {
            series.push({
              ...data,
              value,
              ts,
              dataTime,
              isHaveIntegral: data.isHaveIntegral || false,
              flag: data.flag || null,
              dasFlag: data.dasFlag || null,
              auditFlag: data.auditFlag
            })
          }
        }
      }, tmpKey, dataKey)

      console.timeEnd('format2')
    },
    getData () {
      let currentQuery = {
        beginTime: this.query.beginTime,
        endTime: this.query.endTime,
        siteIds: this.query.siteIds
      }
      this.changeLoadStatus(true)
      this.$api.Aqi.createCaseLibrary(currentQuery).then(data => {
        this.currentPage = 1
        if (data.length === 0) {
          this.datasList = []
          this.list = []
          this.total = 0
          return
        }
        let {gradeLevel} = this
        let tmpList = data.map(el => {
          let aqiPollutionTimes = ''
          el.aqiPollutionTimes.forEach(item => {
            aqiPollutionTimes += item.beginTime + ' - ' + item.endTime + '\n'
          })
          return {
            ...el,
            aqiGradeStr: gradeLevel[el.aqiGrade],
            dataTime: el.dataTime,
            maxAqi: el.maxAqi,
            siteId: el.siteId,
            primaryPollutionsStr: el.primaryPollutions.replace('H8O3', 'O3'),
            aqiPollutionTimesStr: aqiPollutionTimes
          }
        })

        this.datasList = Object.freeze(tmpList)
        this.total = tmpList.length
        if (this.total > this.pageSize) {
          for (let index = 0; index < this.pageSize; index++) {
            this.list.push(tmpList[index])
          }
        } else {
          this.list = tmpList
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getCharacteristicList () {
      this.$api.Characteristic.getList().then(data => {
        this.characteristicList = Object.freeze(data)
      }).catch(console.error)
    }
  },
  created () {
    this.getCharacteristicList()
  }

}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/11PollutionCases/01CreatePollutionCases/index.vue